<template>
    <div class="buildingConfig clearfix">
        <div class="left">
            <div class="title">校区组织</div>
            <div class="box">
                <div class="tree-box">
                    <el-tree highlight-current ref="schoolOrganization" :data="schoolOrganization" :props="schoolOrganizationProp" node-key="id" :expand-on-click-node="false" @node-click="handleNodeClick" :default-expanded-keys="expandNodes" @node-expand="nodeExpandHandle" @node-collapse="nodeCollapseHandle">
                        <!-- 2019-07-05宿管与子贵3.0融合，去掉宿管系统对楼栋的管理，本页只保留查询和导出 -->
                        <span class="custom-tree-node" slot-scope="{ node, data }">
                            <span v-if="node.level == 1">
                                <span class="label-text">{{node.label}}</span>
                                <!-- <span v-if="user.style !== K12TYPE"  class="icon el-icon-plus" @click.stop="showSchoolAreaAdd = true;editType = 0;schoolAreaAddForm.id=''"></span> -->
                            </span>
                            <span v-if="node.level == 2">
                                <span class="label-text icon-college">{{node.label}}</span>
                                <!-- <span class="el-icon-plus icon" @click.stop="addBuilding(data)"></span>
                                <span v-if="user.style !== K12TYPE" class="el-icon-edit-outline icon" @click.stop="editSchoolArea(data)"></span>
                                <span v-if="user.style !== K12TYPE" class="el-icon-delete icon" @click.stop="deleteSchoolArea(data)"></span> -->
                            </span>
                            <span v-if="node.level == 3">
                                <span class="label-text icon-building">{{node.label}}</span>
                                <!-- <span class="el-icon-plus icon" @click.stop="addRoom(data, node)"></span>
                                <span class="el-icon-edit-outline icon" @click.stop="editBuilding(data)"></span>
                                <span class="el-icon-delete icon" @click.stop="deleteBulding(data)"></span> -->
                            </span>
                        </span>
                    </el-tree>
                </div>

            </div>
        </div>
        <div class="right">
            <div class="operation-panel">
                <!-- 2019-07-05宿管与子贵3.0融合，去掉宿管系统对楼栋的管理，本页只保留查询和导出 -->
                <!-- <span class="btn import" @click="openImportDialog">
                    导入宿舍
                </span> -->
                <span class="btn export" @click="exportExl" :class="{'disable': !clickHouse}">
                    导出宿舍
                </span>
                <el-input class="input" placeholder="请输入宿舍名称查询" v-model="buildingName">
                    <el-button slot="append" icon="el-icon-search" @click="queryRoomByName">查询</el-button>
                </el-input>
            </div>
            <div class="list-wrapper" :loading="listloading">
                <div v-if="!floorList || floorList.length == 0" style="text-align:center;padding:20px;color:#333">暂无数据</div>
                <div class="list" v-for="(floor, i) in floorList" :key="i" v-if="floor.dormitoryList">

                    <div class="floor">{{floor.floorName}}</div>
                    <ul class="room-list">
                        <li class="room" v-for="(room, j) in floor.dormitoryList" :key="j">
                            <!-- 2019-07-05宿管与子贵3.0融合，去掉宿管系统对楼栋的管理，本页只保留查询和导出 -->
                            <!-- <div class="bg">
                                <div class="btn-box">
                                    <div class="edit">
                                        <el-button @click="openRoomEditDialog(room)">编辑</el-button>
                                    </div>
                                    <div class="delete">
                                        <el-button @click="deleteRoom(floor.dormitoryList,j)">删除</el-button>
                                    </div>
                                </div>
                            </div> -->
                            <div class="name">{{room.dormitoryName}}</div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- 编辑宿舍 -->
        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" title="编辑宿舍" :visible.sync="showRoomEditDialog" width="500px" height="298px" :before-close="closeDialog" left>
            <el-form ref="roomEditForm" label-width="180px" :model="roomEditForm" v-if="currentFocusRoom">
                <div class="warning-wrapper">
                    <span class="el-icon-warning warning"></span>
                    带
                    <span class="red">*</span>号的为必填项,宿舍已住人情况下仅可编辑宿舍名称！
                </div>
                <el-form-item label="宿舍名称:" prop="dormitoryName" :rules="[{ required: true, message: '宿舍名称不能为空'},vRules.illegalCharacter]">
                    <el-input v-inputexclude="'\\s+'" v-model="roomEditForm.dormitoryName"></el-input>
                </el-form-item>
                <el-form-item label="每间宿舍可入住人数:" prop="bedNum" :rules="[{ required: true, message: '每间宿舍可入住人数不能为空'},vRules.maxInteger(24),vRules.minInteger(1)]">
                    <el-input maxlength="2" v-model="roomEditForm.bedNum" v-inputexclude="'\\s+'" :disabled="!roomAvailable"></el-input>

                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="comfirmRoomEdit">确定</el-button>
                <el-button @click="cancelFormEdit('showRoomEditDialog','roomEditForm')">取消</el-button>
            </span>
        </el-dialog>
        <!-- 添加和编辑校区 -->
        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :before-close="closeDialog" :title="editType == 0 ? '添加校区' : '编辑校区'" :visible.sync="showSchoolAreaAdd" width="570px" height="298px" left>
            <el-form ref="schoolAreaAddForm" label-width="140px" :model="schoolAreaAddForm">
                <div class="warning-wrapper">
                    <span class="el-icon-warning warning"></span>
                    <template v-if="editType == 0">带
                        <span class="red">*</span>号的为必填项（
                        <span class="red">校区只能添加在学校节点下！</span>）</template>
                    <template v-else>带
                        <span class="red">*</span>号的为必填项</template>
                </div>
                <el-form-item label="所属学校:">
                    <el-input v-model="schoolAreaAddForm.school" disabled readonly></el-input>
                </el-form-item>
                <el-form-item label="校区名称:" prop="schoolName" :rules="[
                    { required: true, message: '校区名称不能为空',trigger:'blur'},vRules.illegalCharacter,
                    ]">
                    <el-input v-model="schoolAreaAddForm.schoolName" placeholder="限20字符数内，不允许输入特殊字符" maxlength="20" v-inputexclude="'\\s+'"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="comfirmSchoolAddForm(0)">确定</el-button>
                <el-button @click="cancelFormEdit('showSchoolAreaAdd','schoolAreaAddForm')">取消</el-button>
            </span>
        </el-dialog>
        <!-- 添加和编辑楼栋 -->
        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :title="editType == 0 ? '添加楼栋' : '编辑楼栋'" :visible.sync="showBuildingAdd" width="570px" height="400px" left>
            <el-form ref="buildingAddForm" label-width="180px" :model="buildingAddForm">
                <div class="warning-wrapper">
                    <span class="el-icon-warning warning"></span>
                    带
                    <span class="red">*</span>号的为必填项
                    <span v-if="editType === 1">,该楼栋已住人情况下仅可编辑楼栋名称</span>
                    <span v-else>(
                        <span class="red">楼栋只能添加在校区节点下</span>)</span>
                </div>
                <el-form-item label="所属校区:">
                    <!-- <el-input v-if="user.style===K12TYPE" v-model="schoolAreaAddForm.schoolNum" disabled readonly></el-input> -->
                    <el-select  v-model="buildingAddForm.schoolNum" :disabled="disableEditBuildingForm || user.style===K12TYPE">
                        <el-option v-for="(capmus, index) in capmusList" :key="index" :value="capmus.schoolNum" :label="capmus.schoolName"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="楼栋名称:" prop="houseName" :rules="[{ required: true, message: '楼栋名称不能为空',trigger: 'blur'},vRules.illegalCharacter]">
                    <el-input v-model="buildingAddForm.houseName" maxlength="20" placeholder="限20字符以内，不允许输入特殊字符" v-inputexclude="'\\s+'"></el-input>
                </el-form-item>
                <!-- <el-form-item  label="性别属性:"
                    prop="gender"
                    :rules="[{ required: true, message: '性别属性不能为空'}]"
                    >
                    <el-select v-model="buildingAddForm.gender" placeholder="-请选择入住学生类别-">
                        <el-option
                            v-for="item in [{label:'男',value:'0'},{label:'女',value:'1'}]"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <div class="red" style="font-size: 12px;line-height: 20px;">* 若同一楼栋存在男女混住情况，建议按两栋宿舍楼分别添加</div>
                    <span class="red"></span>
                </el-form-item> -->
                <el-form-item label="楼层数:" prop="floorNum" :rules="[{ required: true, message: '楼层数不能为空', trigger: 'blur'},
                    vRules.maxInteger(99),vRules.minInteger(1)]">
                    <el-input v-model="buildingAddForm.floorNum" maxlength="2" placeholder="限100以内的正整数" :disabled="disableEditBuildingForm" v-inputexclude="'\\s+'"></el-input>
                </el-form-item>
                <el-form-item label="每间宿舍可入住人数：" prop="everyDormitoryPeopleNum" :rules="[{ required: true, message: '每间宿舍可入住人数不能为空', trigger: 'blur'},
                    vRules.maxInteger(24),vRules.minInteger(1)]">
                    <el-input v-model="buildingAddForm.everyDormitoryPeopleNum" maxlength="2" placeholder="限24以内的正整数" :disabled="disableEditBuildingForm" v-inputexclude="'\\s+'"></el-input>
                </el-form-item>
                <el-form-item label="每层宿舍数量：" prop="everyFloorDormitoryNum" :rules="[vRules.maxInteger(99),vRules.minInteger(1)]">
                    <el-input v-model="buildingAddForm.everyFloorDormitoryNum" maxlength="2" placeholder="限100以内的正整数" :disabled="disableEditBuildingForm" v-inputexclude="'\\s+'"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="comfirmBuildingAddForm">确定</el-button>
                <el-button @click="cancelFormEdit('showBuildingAdd','buildingAddForm')">取消</el-button>
            </span>
        </el-dialog>
        <!-- 添加宿舍房间 -->
        <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" title="批量添加宿舍" :visible.sync="showRoomAddForm" width="570px" height="600px" left>
            <el-form ref="roomAddForm" :model="roomAddForm">
                <div class="warning-wrapper" style="max-height:400px;over-flow:auto">
                    <span class="el-icon-warning warning"></span>
                    输入完一个宿舍名称后按回车键，再输入第二个宿舍名称，依此类推。宿舍名限制20(含)字符数以内，不允许特殊字符和空格。
                </div>
                <template v-if="currentFocusBuilding">
                    <el-form-item v-for="(floor, index) in currentFocusBuilding" :key="index">
                        <p style="line-height: 20px;">楼层{{index+1}}:({{currentClickTreeNode ? currentClickTreeNode.lable + floor.floorName : ''}})</p>
                        <!-- <div  style="height:40px;" @keydown.prevent.enter="pushRoom(floor,$event)"
                        > </div> -->
                        <div class="input-div">
                            <span class="name-box" v-for="(room, index) in floor.dormitoryList" :key="index">
                                <i class="el-icon-close" @click="deleteSpan(floor.dormitoryList, index)"></i>
                                {{room.dormitoryName}}</span>
                            <input v-if="index ===0" ref="batchInput" style="width: 165px;" maxlength="20" @keydown.enter.prevent="pushRoom(floor,$event)" class="invisible" v-model="floor.dormitoryStr" v-inputexclude="'\\s+'" />
                            <input v-else style="width: 165px;" maxlength="20" @keydown.enter.prevent="pushRoom(floor,$event)" class="invisible" v-model="floor.dormitoryStr" v-inputexclude="'\\s+'" />
                        </div>

                    </el-form-item>
                </template>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="comfirmAddRoom">保存</el-button>
                <el-button @click="cancelFormEdit('showRoomAddForm','roomAddForm')">取消</el-button>
            </span>
        </el-dialog>
        <!-- 导入 -->
        <import-upload :showImport.sync="showImport" :importObj="importObj" @importFinishCallback="afterImport()"></import-upload>
    </div>
</template>

<script>
import api from '@/api'
import { session } from '@/util'
import vRules from '@/config/validate_rules';
import importUpload from '@/components/importUpload/importUpload.vue';
import { mapState } from 'vuex';
export default {
    components: {
        importUpload
    },
    props: {},
    data () {
        const user = session('user');

        return {
            listloading: false,
            // 表单验证规则
            vRules,
            editType: null,
            user: user,
            houseId: null,
            showRoomAddForm: false,
            roomAddForm: {},
            // 编辑楼栋
            disableEditBuildingForm: false,
            showBuildingAdd: false,
            buildingAddForm: {
                everyDormitoryPeopleNum: '',//每间宿舍可入住人数
                everyFloorDormitoryNum: '',//每层宿舍数量
                floorNum: '',//楼层数
                houseId: '',//宿舍Id
                houseName: '',//宿舍名称
                manageName: '',
                manageUser: '',
                remark: '',
                schoolId: user.schoolId,
                schoolNum: '',//校区ID
                status: '',
            },
            // 校区
            showSchoolAreaAdd: false,
            schoolAreaAddForm: {
                school: user.schoolName,
                schoolId: user.schoolId,
                userId: user.accountId,
                schoolName: '', // 学院名称用于新增
                id: ''
            },
            // 宿舍
            roomEditForm: {
                bedNum: '',
                dormitoryCode: "",
                dormitoryId: '',
                dormitoryName: "",
                floorId: '',
                houseId: '',
                manageName: "",
                manageUser: '',
                remark: "",
                schoolId: '',
                schoolNum: ''
            },
            // 当前点击的宿舍楼信息
            currentFocusBuilding: null,
            currentFocusRoom: null,
            showRoomEditDialog: false,
            showRoomDeleteDialog: false,
            buildingName: '',
            // 最终的树数据
            schoolOrganization: null,
            schoolOrganizationProp: {
                label: 'lable',
                children: 'children'
            },
            floorList: null,
            capmusList: null,
            importObj: null,
            showImport: false,
            clickHouse: false, // 辨别导入按钮是否禁用，点击楼栋时启用
            currentClickTreeNode: null,
            roomAvailable: false, // 宿舍是否有人入住，没有人入住则为true
            expandNodes: [],
            currentNodeInLeftTree: null,

        }
    },
    watch: {},
    computed: {
        departName () {
            return this.schoolAreaAddForm.schoolName;
        },
        ...mapState([
            'K12TYPE',
            'UNK12TYPE'
        ])
    },
    methods: {
        afterImport () {
            var node = this.$refs.schoolOrganization.getNode(this.currentNodeInLeftTree)
            this.handleNodeClick(this.currentNodeInLeftTree, node);
        },
        closeDialog (done) {
            this.$refs.schoolAreaAddForm && this.$refs.schoolAreaAddForm.resetFields();
            this.$refs.buildingAddForm && this.$refs.buildingAddForm.resetFields();
            this.$refs.roomEditForm && this.$refs.roomEditForm.resetFields();
            this.$refs.roomAddForm && this.$refs.roomAddForm.resetFields();
            done();
        },
        exportExl () {
            if (!this.clickHouse) {
                return;
            }
            let node = this.$refs.schoolOrganization.getCurrentNode();
            if (node) {
                let param = {
                    schoolNum: node.schoolNum,
                    houseId: node.id
                }
                api.systemConfig.exportDormitoryList(param).then((res) => {
                    var key, value;
                    [key, value] = Object.entries(res.data)[0];
                    this.$common.globalExportExl(key, value, '宿舍导出记录');
                })
            }
        },
        // downFile (response, name) {
        //     if (!response) {
        //         return
        //     }
        //     let url = window.URL.createObjectURL(new Blob([response]));
        //     let link = document.createElement('a');
        //     link.style.display = 'none';
        //     link.href = url;
        //     link.setAttribute('download', name);
        //     document.body.appendChild(link);
        //     link.click();

        // },
        // 编辑楼栋
        comfirmBuildingAddForm () {
            this.houseId = this.buildingAddForm.houseId;
            this.$refs.buildingAddForm.validate((valid, obj) => {
                if (valid) {
                    if (this.editType == 0) {
                        api.systemConfig.addBuilding(this.buildingAddForm)
                            .then((res) => {
                                if (res.code == 0) {
                                    this.queryLeftTree();
                                    this.updateFloorListByCurrentNode();
                                    this.cancelFormEdit('showBuildingAdd', 'buildingAddForm');
                                    this.openAddComfirmDialog('添加楼栋', '继续添加楼栋'
                                        , () => {
                                            this.addBuilding(this.currentClickTreeNode)                                        }
                                    );
                                } else {
                                    this.$message(res.message);
                                }
                            })
                    } else if (this.editType == 1) {
                        api.systemConfig.updateBuilding(this.buildingAddForm)
                            .then((res) => {
                                if (res.code == 0) {
                                    this.queryLeftTree();
                                    this.updateFloorListByCurrentNode();
                                    this.cancelFormEdit('showBuildingAdd', 'buildingAddForm');
                                } else {
                                    this.$message(res.message);
                                }
                            })
                    }

                }
            })

        },
        addBuilding (data) {
            this.querySchoolCapmus();
            this.disableEditBuildingForm = false;
            this.currentClickTreeNode = data;
            this.showBuildingAdd = true;
            this.editType = 0;
            this.buildingAddForm.houseId = '';
            this.buildingAddForm.schoolNum = data.schoolNum;
        },
        editBuilding (data) {
            this.querySchoolCapmus();
            Promise.all([api.systemConfig.buildingDetail(data.id),
            api.systemConfig.getUseCountByHouseId(data.id)])
                .then((resList) => {
                    let detail = resList[0];
                    let useBedTotal = resList[1];
                    if (detail.code == 0 && useBedTotal.code == 0) {
                        this.disableEditBuildingForm = useBedTotal.data > 0;
                        this.showBuildingAdd = true;
                        this.editType = 1;
                        this.$nextTick(() => {
                            this.buildingAddForm.houseId = data.id;
                            this.buildingAddForm.houseName = data.lable;
                            this.buildingAddForm.everyDormitoryPeopleNum = detail.data.everyDormitoryPeopleNum;
                            this.buildingAddForm.everyFloorDormitoryNum = detail.data.everyFloorDormitoryNum || '';
                            this.buildingAddForm.floorNum = detail.data.floorNum;
                            this.buildingAddForm.schoolNum = detail.data.schoolNum;
                        })

                    } else {
                        detail.code !== 0 && this.$message(detail.message);
                        useBedTotal.code !== 0 && this.$message(useBedTotal.message);
                    }
                })


        },
        updateFloorListByCurrentNode () {
            let data = this.$refs.schoolOrganization.getCurrentNode();
            if (data) {
                if (data.leavel == 2) {
                    this.houseId = data.id;
                    this.getAllFloorDormitory();
                }
            }


        },
        deleteBulding (data) {
            this.buildingAddForm.houseId = data.id;
            this.openDeleteDialog(1, () => {
                api.systemConfig.deleteBuilding(this.buildingAddForm)
                    .then((res) => {
                        if (res.code == 0) {
                            this.queryLeftTree();
                            this.floorList = null;
                            this.openSuccessDialog('删除成功', '删除成功')
                        } else {
                            this.openDeleteFailDialong();
                        }
                    })
            })

        },
        // 编辑校区
        editSchoolArea (data) {
            this.showSchoolAreaAdd = true;
            this.editType = 1;
            this.$nextTick(() => {
                this.schoolAreaAddForm.id = data.id;
                this.schoolAreaAddForm.schoolName = data.lable;
            })

        },
        deleteSchoolArea (data) {
            this.openDeleteDialog(1, () => {
                this.schoolAreaAddForm.id = data.id;
                api.systemConfig.deleteSchoolCampus(this.schoolAreaAddForm).then((res) => {
                    if (res.code == 0) {
                        this.openSuccessDialog('删除成功', '删除成功')
                        this.queryLeftTree();
                    } else {
                        if (res.code === -1) {
                            this.openDeleteFailDialong('校区下已有学生');

                        } else {
                            this.openDeleteFailDialong();

                        }
                    }
                })

            })
        },
        comfirmSchoolAddForm () {
            let successcallback = (res) => {
                if (res.code == 0) {
                    this.queryLeftTree();
                    this.cancelFormEdit('showSchoolAreaAdd', 'schoolAreaAddForm');
                    this.$nextTick(() => {
                        this.openAddComfirmDialog('添加校区', '继续添加校区'
                            , () => {
                                this.showSchoolAreaAdd = true;                            }
                        );

                    })
                } else {
                    this.$message({
                        type: 'info',
                        message: res.message
                    });
                }
            };

            this.$refs.schoolAreaAddForm.validate((valid, obj) => {
                if (valid) {
                    if (this.editType == 0) { // 新增
                        api.systemConfig.addSchoolCampus(this.schoolAreaAddForm).then((res) => {
                            successcallback(res);
                        })
                    } else if (this.editType == 1) { // 编辑
                        api.systemConfig.updateSchoolCampus(this.schoolAreaAddForm).then((res) => {
                            if (res.code == 0) {
                                this.queryLeftTree();
                                this.cancelFormEdit('showSchoolAreaAdd', 'schoolAreaAddForm');
                            } else {
                                this.$message(res.message);
                            }
                        })

                    }
                }
            });


        },
        // 编辑宿舍
        openRoomEditDialog (room) {
            api.systemConfig.qryDormitoryUseAndEmptyCount(room.dormitoryId).then((res) => {
                if (res.code === 0) {
                    this.roomAvailable = res.data.useNum === 0;
                    this.showRoomEditDialog = true;
                    this.$nextTick(() => {
                        this.roomEditForm.bedNum = room.bedNum;
                        this.roomEditForm.dormitoryName = room.dormitoryName;
                        this.roomEditForm.dormitoryId = room.dormitoryId;

                        this.currentFocusRoom = room;
                    })

                } else {
                    this.$message(res.message);
                }
            })

        },
        comfirmRoomEdit () {
            this.$refs.roomEditForm.validate((valid, obj) => {
                if (valid) {
                    this.showRoomEditDialog = false;
                    api.systemConfig.updateDormitory(this.roomEditForm)
                        .then((res) => {
                            if (res.code == 0) {
                                this.currentFocusRoom.dormitoryName = this.roomEditForm.dormitoryName;
                                this.currentFocusRoom.bedNum = this.roomEditForm.bedNum;
                            } else {
                                this.$message(res.message);
                            }
                        })
                }

            });
        },
        deleteRoom (dormitoryList, j) {
            this.openDeleteDialog(0, () => {
                let room = dormitoryList[j];
                this.roomEditForm.dormitoryId = room.dormitoryId;
                api.systemConfig.deleteDormitory(this.roomEditForm)
                    .then((res) => {
                        if (res.code == 0) {
                            dormitoryList.splice(j, 1);
                            this.openSuccessDialog('删除成功', '删除成功');
                        } else {
                            this.openDeleteFailDialong();
                        }
                    })
            })
        },
        addRoom (data, node) {
            this.currentClickTreeNode = data;
            api.systemConfig.getAllFloorDormitory({ houseId: data.id })
                .then((res) => {
                    if (res.code == 0) {
                        this.currentFocusBuilding = res.data;
                        this.currentFocusBuilding.dormitoryList = [];
                        this.currentFocusBuilding = res.data.map((item) => {
                            item.dormitoryList = [];
                            return item;
                        })

                        this.showRoomAddForm = true;
                        this.editType = 0;
                        this.$nextTick(() => {
                            this.$refs.batchInput[0].focus()
                        })
                    }
                })

        },
        pushRoom (floor, event) {
            let reg = new RegExp("[\s`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]+");
            if (floor.dormitoryStr == '' || floor.dormitoryStr == undefined || floor.dormitoryStr == null) {
                this.$message('请输入宿舍名称');
                return;
            }
            if (reg.test(floor.dormitoryStr)) {
                this.$message('不能输入非法字符和空格!');
                return;
            }
            for (const item of floor.dormitoryList) {
                if (floor.dormitoryStr == item.dormitoryName) {
                    // this.$message('同一层楼名字不能重复!');
                    floor.dormitoryStr = '';
                    return;
                }
            }
            floor.dormitoryList = floor.dormitoryList ? floor.dormitoryList : [];
            let text = floor.dormitoryStr;
            console.log(text);
            floor.dormitoryList.push({ dormitoryName: text })
            floor.dormitoryStr = '';
        },
        deleteSpan (list, index) {
            list.splice(index, 1);
        },
        comfirmAddRoom () {
            var count = 0;
            for (const item of this.currentFocusBuilding) {
                if (item.dormitoryList.length == 0) {
                    count++;
                }
            }
            if (count == this.currentFocusBuilding.length) {
                this.$message('请至少添加一个宿舍');
                return;
            }
            api.systemConfig.saveDormitoryList({
                houseId: this.currentFocusBuilding[0].houseId,
                floorList: this.currentFocusBuilding            }).then((res) => {
                if (res.code == 0) {
                    this.getAllFloorDormitory();
                    this.showRoomAddForm = false;
                    this.currentFocusBuilding = null;
                    this.openSuccessDialog('批量添加宿舍', '添加成功');
                } else {
                    let msg = '';
                    if (res.data) {
                        res.data.forEach((item) => {
                            msg += item + ';'
                        })
                        this.$message(msg);
                    } else {
                        this.$message(res.message);
                    }

                }
            })
        },
        queryRoomByName () {
            this.getAllFloorDormitory(this.buildingName);
        },
        cancelFormEdit (dialog, form) {
            this[dialog] = false;
            this.$refs[form].resetFields();

        },
        openSuccessDialog (title, msg, callback) {
            let html = `<div style="width:400px;height:158px;padding:30px 50px;text-align: center">
                            <div style="margin-bottom:20px;"><span class="el-icon-success" style="color: #FD8C25;font-size: 50px;"></span> </div>
                            <p>${msg}!</p>
                        </div>`;


            this.$alert(html, title, {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                showCancelButton: false
            }).then(() => {
            })
        },
        openDeleteFailDialong (msg = '宿舍已有人员入住') {
            let html = `<div style="width:400px;height:158px;padding:30px 50px;text-align: center">
                            <div style="margin-bottom:20px;"><span class="el-icon-error" style="color: #ED1C24;font-size: 50px;"></span> </div>
                            <p>${msg}，无法删除！</p>
                        </div>`;

            this.$alert(html, '删除失败', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                showCancelButton: false
            }).then(() => {
            })
        },
        openAddComfirmDialog (title, btn, callback) {
            let html = `<div style="width:400px;height:158px;padding:30px 50px;text-align: center">
                            <div style="margin-bottom:20px;"><span class="el-icon-success" style="color: #FD8C25;font-size: 50px;"></span> </div>
                            <p>添加成功!</p>
                        </div>`;


            this.$alert(html, title, {
                dangerouslyUseHTMLString: true,
                confirmButtonText: btn,
                showCancelButton: true,
                cancelButtonText: '关闭'
            }).then(() => {
                callback();
            })
        },
        openDeleteDialog (type, callback) {
            let html2 = type == 0 ? `<p>删除后下级宿舍信息也会删除！</p></div>` : `</div>`;
            let html = `<div style="width:400px;height:158px;padding:30px 50px;text-align: center">
                            <div style="margin-bottom:20px;"><span class="el-icon-warning" style="color: #FD8C25;font-size: 50px;"></span> </div>
                            <p>确认删除？</p> ` + html2;



            this.$alert(html, '确认删除？', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定删除',
                showCancelButton: true
            }).then(() => {
                callback();
            })
        },
        queryLeftTree () {
            api.common.querySchoolHouseTree(this.user.schoolId)
                .then((res) => {
                    if (res.code == 0) {
                        this.schoolOrganization = res.data.treeDTOList;
                    }
                }).then(() => {
                    if (this.currentNodeInLeftTree) {
                        this.$refs.schoolOrganization.setCurrentKey(this.currentNodeInLeftTree.id);
                    } else {
                        this.$nextTick(() => {
                            let id = this.schoolOrganization[0].id;
                            this.$refs.schoolOrganization.setCurrentKey(id);
                            this.currentNodeInLeftTree = this.schoolOrganization[0];
                        })
                    }
                })
        },
        getAllFloorDormitory (roomName = '') {
            let param = {
                houseId: this.houseId,
                dormitoryName: roomName
            };
            api.systemConfig.getAllFloorDormitory(param)
                .then((res) => {
                    if (res.code == 0) {
                        this.floorList = res.data;
                        this.initialFloorList = this.floorList;
                    }
                })
        },
        handleNodeClick (data, node) {
            this.currentNodeInLeftTree = data;
            // 点击的是楼栋才有反应
            if (node.level == 3) {
                this.buildingName = '';
                this.houseId = data.id;
                this.getAllFloorDormitory();
                this.clickHouse = true;
            } else {
                this.clickHouse = false;
            }
        },
        openImportDialog () {
            this.showImport = true;
            this.importObj = {
                title: '导入宿舍',
                text: '点击下载宿舍导入模板',
                url: '/static/宿舍导入模板.xlsx',
                api: api.systemConfig.importHostel,
                key: 'hostelFile'
            };
        },
        nodeExpandHandle (data) {
            this.expandNodes.push(data.id);
        },
        nodeCollapseHandle (data) {
            this.expandNodes = this.expandNodes.filter((nodeId) => {
                return nodeId !== data.id;
            })
        },
        querySchoolCapmus () {
            api.systemConfig.querySchoolCapmus(this.user.schoolId)
                .then((res) => {
                    if (res.code == 0) {
                        this.capmusList = res.data;
                    }
                })
        }

    },
    created () {
    },
    mounted () {
        this.queryLeftTree();

    }
}
</script>
<style lang="scss" >
html {
  height: auto;
}
.red {
  color: red;
}
.warning-wrapper {
  margin-bottom: 24px;
  line-height: 20px;
}

.el-message-box__header {
  padding: 10px 15px 10px;
  background-color: #409eff;
  .el-message-box__title {
    color: #fff;
  }
}
.el-message-box__headerbtn .el-message-box__close {
  color: #fff;
}
.el-button {
  padding: 6px 15px;
}
.el-form-item__label,
.el-dialog__body {
  color: #333;
}
.vl-notify {
  z-index: 2018;
  padding: 0;
}
.vl-notify .vl-notify-btns {
  padding: 0;
  text-align: center;
}
.warning {
  color: #e6a23c;
}
.down-tepmlate {
  color: #26aef3;
  padding-top: 10px;
  i {
    display: inline-block;
    vertical-align: bottom;
    width: 20px;
    height: 20px;
    margin-right: 5px;
    background: url('down.png') 0 0 no-repeat;
  }
  a {
    text-decoration: underline;
    color: #26aef3;
    font-size: 13px;
  }
}
.buildingConfig {
  width: 1200px;
  padding: 0;
  margin: 0;
  overflow: hidden;
  .left {
    width: 300px;
    min-height: 630px;
    float: left;
    .title {
      width: 100%;
      padding: 0 20px;
      height: 40px;
      line-height: 40px;
      color: #fff;
      background-color: #26aef3;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }
    .box {
      padding: 0px 0 0 0;
      height: 590px;
      border: 1px solid #dbdbdb;
      border-top: none;
      overflow: auto;
      .tree-box {
        color: #333;
        height: 100%;
        .label-text {
          margin-right: 15px;
          color: #333;
        }
        .icon {
          margin-right: 8px;
          color: #333;
          font-weight: bold;
        }
      }
    }
  }
  .right {
    width: 860px;
    margin: 0 20px;
    float: left;
    border: 1px solid #dbdbdb;
    .operation-panel {
      height: 40px;
      line-height: 40px;
      padding: 0 20px;
      background-color: #f0f0f0;
      .input {
        width: 300px;
        float: right;
        margin-top: 5px;
        .el-input__inner {
          border: 1px solid #26aef3;
          border-right: none;
        }
        .el-input-group__append {
          border: 1px solid #26aef3;
          border-left: none;
          background-color: #26aef3;
          color: #fff;
        }
      }
      .btn {
        display: inline-block;
        margin-right: 40px;
        color: #333;
        font-size: 14px;
        cursor: pointer;
        &.export {
          &:before {
            content: '';
            display: inline-block;
            vertical-align: middle;
            width: 22px;
            height: 22px;
            background-image: url('export.png');
          }
          &.disable {
            color: #aaa;
          }
          &:hover {
            color: #26aef3;
            &:not(.disable):before {
              background-image: url('export-blue.png');
            }
            &.disable {
              color: #aaa;
            }
          }
        }
        &.import {
          &:before {
            display: inline-block;
            vertical-align: middle;
            content: '';
            width: 18px;
            height: 18px;
            background-image: url('import.png');
          }
          &:hover {
            color: #26aef3;
            &:before {
              background: url('import-blue.png') -2px -2px no-repeat;
            }
          }
        }
      }
    }
    .list-wrapper {
      min-height: 500px;
      .list {
        padding: 20px 22px 9px 18px;
        border-bottom: 1px solid #dbdbdb;
        &:last-child {
          border-bottom: none;
        }
        .floor {
          line-height: 20px;
          color: #ffb324;
          margin-bottom: 15px;
        }
        .room-list {
          margin-bottom: 20px;
          .room {
            display: inline-block;
            margin-bottom: 28px;
            margin-right: 65px;
            text-align: center;
            &:last-child {
              margin-right: 0;
            }
            .bg {
              width: 98px;
              height: 110px;
              background: url('room.png') 0 6px no-repeat;
              &:hover > .btn-box {
                display: block;
              }
              .btn-box {
                display: none;
                .edit {
                  padding-top: 24px;
                  margin-bottom: 10px;
                  .el-button {
                    padding: 6px 15px;
                    color: #fff;
                    background: #ffb324;
                    border: 1px solid #ffb324;
                  }
                }
                .delete {
                  .el-button {
                    padding: 6px 15px;
                    color: #606266;
                    background: #fff;
                  }
                }
              }
            }
            .name {
              text-align: center;
            }
          }
        }
      }
    }
  }
  .input-div {
    padding: 10px;
    height: 70px;
    border: 1px solid #ccc;
    overflow: auto;
    .name-box {
      float: left;
      position: relative;
      background-color: #ffb324;
      color: #fff;
      min-width: 50px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      margin: 0 10px 10px 0;
      padding: 0 15px;
      i {
        position: absolute;
        top: 0;
        right: 0;
        transform: scale(0.8);
        cursor: pointer;
      }
    }
    input {
      float: left;
      border: none;
      height: 20px;
      line-height: 20px;
      &:focus {
        outline: none;
      }
    }
  }
  .el-dialog__body {
    max-height: 550px;
    overflow: auto;
  }
  .import-dialog {
    padding: 0 20px 20px 20px;
    .input-text {
      width: 250px;
      margin-right: 10px;
    }
    .rel-import-btn {
      position: relative;
      display: inline-block;
      vertical-align: middle;
      width: 140px;
      height: 30px;
      color: #fff;
      background-color: #e6a23c;
      border-radius: 4px;
      text-align: center;
      line-height: 30px;
      cursor: pointer;
      .import-btn {
        position: absolute;
        left: 0;
        width: 140px;
        height: 30px;
        z-index: 2;
        opacity: 0;
        cursor: pointer;
      }
    }
  }
  .el-form-item__error {
    top: 32px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/systemConfig/buildingConfig.vue